// ----------------------------------------------
// ----------------------------------------------
// global variable
// ----------------------------------------------
// ----------------------------------------------
var active = 'is-active';
var humST  = '';


// ----------------------------------------------
// lib wow
// ----------------------------------------------
new WOW().init();

// ----------------------------------------------
// smooth Scroll
// ----------------------------------------------
$(function () {
    var hdHeight = $('.hd').outerHeight() + 10;
    var urlHash = location.hash;
    var animeSpeed = 500;

    if (urlHash) {
        history.replaceState('', document.title, window.location.pathname);
        setTimeout(function () {
            var target = $(urlHash);
            var position = target.offset().top - hdHeight;
            $('body,html').stop(true, true).animate({ scrollTop: position }, 0, "swing");
        }, 0);
    }
    $('a[href^="#"]').not('.jdgm-write-rev-link').on({
        'click': function () {
            var hdHeight = $('.hd').outerHeight() + 5;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var pdTop = parseInt(target.css('padding-top'));
            var Height = pdTop >= 100 ? hdHeight - (pdTop / 2) : hdHeight;
            var position = target.offset().top - Height;
            $('body,html').stop().animate({ scrollTop: position }, animeSpeed);
            return false;
        }
    });
});

// ----------------------------------------------
// image Switch
// ----------------------------------------------
var $elem = $('.js-image-switch');
var $elem767 = $('.js-image-switch767');
var $elem768 = $('.js-image-switch768');
var sp = '_sp.';
var pc = '_pc.';
var $this;
var wW = window.innerWidth;
var y = 200;

// image Switch
function imageSwitch(element, replacew) {
    element.each(function () {
        $this = $(this);
        if (wW > replacew) $this.attr('src', $this.attr('src').replace(sp, pc));
        else $this.attr('src', $this.attr('src').replace(pc, sp));
    });
}

$(window).on('load', function () {
    if ($($elem)) imageSwitch($elem, 810);
});

$(window).on('resize', function () {
    var resizeTimer;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        wW = window.innerWidth;
        if ($($elem)) imageSwitch($elem, 810);
    }, 100);
});


//--------------------------------------------------
// js-addというclassを持つ要素をクリックすると
// 任意のクラスがtoggleされます。
//--------------------------------------------------
var js_name = 'js-add';
var js_add = document.getElementsByClassName(js_name);
var that = this;

for (var i = 0; i < js_add.length; i++) {
    js_add[i].addEventListener('click', function () {
        if (this.classList.contains(that.active)) this.classList.remove(that.active);
        else this.classList.add(that.active);
    })
}


// ----------------------------------------------
// gnav.accordion
// ----------------------------------------------
$(function () {
    var rWidth = 0;

    accodion();
    window.addEventListener('resize', accodion, false);

    function accodion() {
        var spTarget = $('.is-accordion');
        var pcTarget = $('.js-hover');
        var wWidth = $(window).width();

        spTarget.off('click');
        pcTarget.off('mouseenter mouseleave');

        if (wWidth < 1000) {
            spTarget.on('click', clickEvent);
            if (rWidth >= 1000 ) {
                spTarget.each(function () { $(this).attr('class', 'is-accordion'); });
                spTarget.next().each(function () { $(this).attr('style', ''); });
                rWidth = wWidth;
                console.log('if (rWidth >= 1000 ) ：'+rWidth);
            }
        } else {
            rWidth = wWidth;
            console.log('if (wWidth < 1000)else ：'+rWidth);
            spTarget.each(function () { $(this).attr('class', 'is-accordion'); });
            spTarget.next().each(function () { $(this).attr('style', ''); });
            pcTarget.hover(hoverinEvent, hoveroutEvent);
        }
    }
    function clickEvent() {
        var clickThis = $(this);
        var ThisChild = $(this).children('.is-accordion');

        clickThis.next().stop().slideToggle();
        if(clickThis.hasClass(active)){
            clickThis.removeClass(active);
            ThisChild.next().each(function () { $(this).attr('style', ''); });
        }else{
            clickThis.addClass(active);
        }    
    }
    function hoverinEvent() {
        var hoverThis = $(this).children('.is-accordion');

        hoverThis.toggleClass(active);
        hoverThis.next().stop().fadeIn();
        hoverThis.next().css('display', 'flex');
    }
    function hoveroutEvent() {
        var hoverThis = $(this).children('.is-accordion');

        hoverThis.toggleClass(active);
        hoverThis.next().stop().fadeOut();
    }
});

// ----------------------------------------------
// hm.toggleclass
// ----------------------------------------------
$(function () {
    var rWidth = 0;

    toggleNav();
    window.addEventListener('resize', toggleNav, false);

    function toggleNav() {
        var hamburger = $('.hd__nv__hm');
        var spMenu = $('.hd__menu');
        var wWidth = $(window).width();
        var body = $('body');
        var html = $('html');

        hamburger.off('click', clickHamburger);

        if (wWidth < 1000) {
            hamburger.on('click', clickHamburger);
            if (wWidth < rWidth) {
                spMenu.css({ display: 'block' });
                spMenu.hide();
                rWidth = 0;
            }
        } else {
            rWidth = wWidth;
            spMenu.css({ display: 'flex' });
            if (hamburger.hasClass(active)) hamburger.removeClass(active);
            if (spMenu.hasClass(active)) spMenu.removeClass(active);
            if (body.hasClass(active)) body.removeClass(active);
            if (html.hasClass('scroll-prevent')) html.removeClass('scroll-prevent');
        }
    }
    function clickHamburger() {
        var spMenu = $('.hd__menu');
        var spTarget = $('.is-accordion');
        var body = $('body');

        if(!(spMenu.hasClass(active))){
            humST = $(window).scrollTop();
        }

        $(this).stop().toggleClass(active);
        body.toggleClass(active);

        if (spMenu.hasClass(active)) {
            spMenu.removeClass(active);
            body.removeClass(active);
            spMenu.fadeOut();
            spTarget.each(function () { $(this).attr('class', 'is-accordion'); });
            spTarget.next().each(function () { $(this).attr('style', ''); });
            $('html').removeClass('scroll-prevent');
            $(window).scrollTop(humST);
        } else {
            spMenu.addClass(active);
            spMenu.fadeIn();
            $('html').addClass('scroll-prevent');
            $('html').css('top', -(humST) + 'px');
        }
        return false;
    }
});

// ----------------------------------------------
// hd.totop
// ----------------------------------------------
$(function () {
    var TopBtn = $('.hd__totop');

    // scroll fadein・out
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 300) {
            TopBtn.fadeIn();
        } else {
            TopBtn.fadeOut();
        }
    });
    // totop animation
    TopBtn.click(function () {
        $("body,html").animate(
            {
                scrollTop: 0,
            },
            400
        );
        return false;
    });
});

// ----------------------------------------------
// top.[pick up items] slide & matchheight
// ----------------------------------------------
$('.js-slide').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    pauseOnHover: false,
    fade: false,
    centerPadding: false,
    adaptiveHeight: false,
    slidesToShow: 4,
    arrows: true,
    dots: true,
    responsive: [{
        breakpoint: 811,
        settings: {
            slidesToShow: 3,
        }
    }, {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
        },
    }]
});

$(window).on('resize load', function () {
    setTimeout(function () {
        $('.sec__pickup__card').matchHeight();
    }, 100);
});

// ----------------------------------------------
// top.[find a product] setting item width
// ----------------------------------------------
$(window).on('resize load', function () {
    var Items = $('.sec__tab__li02 > li');
    var firstItem = $('.sec__tab__li02 > li:first-child');
    var firstItem_W = 0;
    var wWidth = $(window).width();

    if (wWidth >= 811) {
        Items.each(function () {
            $(this).css({
                'flex-grow': '1',
                width: '15.43%',
            });
        });
        firstItem_W = firstItem.innerWidth();
        firstItem_W = Math.floor(firstItem_W, 1);
        Items.each(function () {
            $(this).css({
                width: firstItem_W,
                'flex-grow': '0'
            });
        });
    } else {
        Items.each(function () { $(this).attr('style', ''); });
    }
});

// ----------------------------------------------
// top.[find a product] tab switch
// ----------------------------------------------
$(function () {
    var tab = $('.sec__tab__li01 > li[data-href]');
    var content = $('.sec__tab__cnt');

    tab.on('click', function () {
        tab.removeClass(active);
        $(this).addClass(active);

        content.hide();
        $($(this).data('href')).fadeIn('slow');

        return false;
    });
});

// ----------------------------------------------
// page.[menu] accordion
// ----------------------------------------------
$(function () {
    accodion();
    window.addEventListener('resize', accodion, false);

    function accodion() {
        var spTarget = $('.js-page__accordion');
        var wWidth = $(window).width();

        spTarget.off('click');

        if (wWidth <= 810) {
            spTarget.on('click', clickEvent);
        } else {
            spTarget.each(function () { $(this).removeClass(active); });
            spTarget.next().each(function () { $(this).removeAttr('style'); });
        }
    }
    function clickEvent() {
        var clickThis = $(this);

        clickThis.toggleClass(active);
        clickThis.next().stop().slideToggle();
    }
});

// ----------------------------------------------
// page.faq slideToggle
// ----------------------------------------------
$(function () {
    slToggle();

    function slToggle() {
        var Target = $('.js-slToggle');

        Target.on('click', clickEvent);
    }
    function clickEvent() {
        var clickThis = $(this);

        clickThis.toggleClass(active);
        clickThis.next().stop().slideToggle();
    }
});

// ----------------------------------------------
// 商品詳細LVスライダー
// ----------------------------------------------
$('.lv__fig.is-slider').slick({
    infinite: true,
    fade: true,
    autoplay: true,
    arrows: false
});

// ----------------------------------------------
// product.lightbox
// ----------------------------------------------
lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true,
    'disableScrolling': true,
})

// ----------------------------------------------
// product.hulkapp
// ----------------------------------------------
$(function () {
    setTimeout(function () {
        var hulkHeight = $('.hulkapps-volumes').outerHeight() + 40;
        var proTable = $('.product__detail__form__wrap');

        proTable.css({
            'padding-bottom': hulkHeight,
        });
    }, 1000);
});

// ----------------------------------------------
// サイドバーのトグル
// ----------------------------------------------
$('.casestudy__sd__ttl').click(function () {
    if (wW <= 810) {
        $(this).toggleClass('is-active').next().slideToggle();
    }
});
// ----------------------------------------------
// print出力サービス
// ----------------------------------------------
$('.js-slide02').slick({
    centerMode: true,
    centerPadding: '100px',
    dots: true,
    focusOnSelect: true,
    responsive: [{
        breakpoint: 811,
        settings: {
            centerPadding: '20px',
        }
    }]
});
// ----------------------------------------------
// 用紙選択
// ----------------------------------------------
$(function () {

    $('.popup-modal').magnificPopup({
        type: 'inline',
        preloader: false,
        callbacks: {
            open: function open() {
                closeBtn();
            }
        }
    });

    if ($('.popup-img').length) {
        $('.popup-img').magnificPopup({
            type: 'image',
            fixedContentPos: true
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }

    var $children = $('.icc__select__children');
    var original = $children.html();
    $('.icc__select__parent').change(function () {
        var val1 = $(this).val();
        if (val1 == 'epson') {
            $('.icc__cnt').hide();
        } else {
            $('.icc__cnt').hide();
        }
        $children.html(original).find('option').each(function () {
            var val2 = $(this).data('val');
            if (val1 != val2) {
                $(this).not('optgroup,.msg').remove();
            }
        });

        if ($(this).val() === '') {
            $children.attr('disabled', 'disabled');
        } else {
            $children.removeAttr('disabled');
        }

    });
});

$('.icc__select__children').change(function () {
    var selectVal = $('.icc__select__children option:selected').val();
    if (selectVal == '') return;
    $('.icc__cnt').hide();
    $('#' + selectVal).show();
});

// ----------------------------------------------
// mailto @ replace
// ----------------------------------------------
$(function () {
    if ($('.js-nsm').length) {
        $('.js-nsm').each(function () {
            var change_mail_href = $(this).attr('href').replace(',', '@');
            $(this).attr('href', change_mail_href);
            var change_mail_text = $(this).text().replace(',', '@');
            $(this).text(change_mail_text);
        })
    }
});

// ----------------------------------------------
// print service slider & magnificPopup gallery
// ----------------------------------------------
$(function () {
    if ($('.js-slide03').length) {
        $('.js-slide03').slick({
            infinite: true,
            fade: true,
            autoplay: false,
            arrows: true,
            dots: true
        });
        $('.js-slide03 .js-gallery01').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery02').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery03').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery04').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery05').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery06').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
        $('.js-slide03 .js-gallery07').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled:true
            }
        });
    }
});

// 端末がタッチ（タップ）に対応しているか確認する
var touch_event = window.ontouchstart;
var touch_points = navigator.maxTouchPoints;

if (touch_event !== undefined && 0 < touch_points) {
    // タッチ対応端末の処理が入る
    document.body.ontouchstart = function () { };
    document.body.addEventListener('touchstart', function () { }, true);
    document.body.addEventListener('touchstart', function () { }, false);
} else {

}

// ----------------------------------------------
// ヘッダーナビのSP時.hd__menu__li01の位置変更とリンク解除
// ----------------------------------------------
// .hd__menu__li01のリスト取得
var firstListItem = $('.hd__menu__li01 li:eq(0)');
var secondListItem = $('.hd__menu__li01 li:eq(1)');
var lastListItem = $('.hd__menu__li01 li:last');

var parentElement = $(".hd__menu__li02-first"); // 用途・目的から探す
var items = $(".hd__menu__li02-first > li").get(); // 用途・目的から探すの第2階層を全て取得
var pcOrderedItems = $(".hd__menu__li02-first > li").get(); //順番変更前の配列
var firstResizeDone = false; //SP時にリサイズされた時に順番を変える処理をさせないためのフラグ

var ary = {};
for (let i = 0; i < items.length; i++) {
    var key = $(".hd__menu__li02-first > li:eq(" + i + ")").find('span:eq(0)').text();
    var value = $(".hd__menu__li02-first > li:eq(" + i + ")").get();    
    ary[key] = value;
}

var spOrder = [ "印刷",
                "版画",
                "日本画",
                "水彩画",
                "水墨・書道",
                "保存・修復",
                "紙漉き道具・原料",
                "染料・助剤",
                "見本帳・サンプラー",
                "クラフト・手作りキット",
                "ラッピング・装飾紙",
                "インテリア・内装材",
                "文具・雑貨・書籍",
                "ギフト"
                ];

function checkWindowSize() {
    if ($(window).width() < 1000) {
        $(document).on('click', '.is-accordion', function (event) {
            event.preventDefault();
        });
    } else {
        $(document).off('click', '.is-accordion');
    }
}

$(document).ready(function() {
    checkWindowSize();
    if ($(window).width() < 1000) {
        firstListItem.insertAfter(lastListItem);

        var spOrderedItems = spOrder.map(function(key) {
            return ary[key];
        });

        items = spOrderedItems;
        
        items.forEach(function(item) {
            parentElement.append(item);
        });
        
        firstResizeDone = true;
    }
});



$(window).resize(function() {
    checkWindowSize();
    if ($(window).width() < 1000 && !firstResizeDone) {
        firstListItem.insertAfter(lastListItem);

        var spOrderedItems = spOrder.map(function(key) {
            return ary[key];
        });

        items = spOrderedItems;

        items.forEach(function(item) {
            parentElement.append(item);
        });

        firstResizeDone = true;
    } else if ($(window).width() > 1000) {
        secondListItem.before(firstListItem);

        items = pcOrderedItems;

        items.forEach(function(item) {
            parentElement.append(item);
        });

        firstResizeDone = false;
    }
});

// ----------------------------------------------
// スクロールヒント
// ----------------------------------------------
// .hd__menu__li03の中でli要素が14個以上あるものを取得
$('.hd__menu__li03').filter(function() {
    return $(this).find('li').length >= 14;
}).each(function() {
    $(this).addClass('is-scrollHint');
});

// ----------------------------------------------
// 商品詳細ページの動画を自動再生させる
// ----------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("video.media-video").forEach(function (vid) {
    vid.controls = true;
    vid.muted = true;
    vid.autoplay = true;
    vid.loop = true;

    // 念のため属性も追加
    vid.setAttribute('muted', '');
    vid.setAttribute('autoplay', '');
    vid.setAttribute('playsinline', '');

    // リロード
    vid.load();
  });
});